import Vue from 'vue';
import {
  Input,
  DatePicker,
  Checkbox,
  Tooltip,
  Icon,
  Poptip,
  Select,
  Option,
  TimePicker,
  Table,
  Message,
  Spin,
  locale,
  Page,
  Modal,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tag,
  Drawer,
  Divider,
  Col,
  Row,
  Button,
  Badge,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  Alert,
  List,
  Progress, Timeline, TimelineItem,
} from 'view-design';

import 'view-design/dist/styles/iview.css';
import '../assets/css/iview.extend.less';

import lang from 'view-design/dist/locale/en-US';
locale(lang);

Vue.component('i-input', Input);
Vue.component('i-form', Form);
Vue.component('i-tag', Tag);
Vue.component('i-form-item', FormItem);
Vue.component('i-date-picker', DatePicker);
Vue.component('i-time-picker', TimePicker);
Vue.component('i-check-box', Checkbox);
Vue.component('i-tool-tip', Tooltip);
Vue.component('i-icon', Icon);
Vue.component('i-poptip', Poptip);
Vue.component('i-drawer', Drawer);
Vue.component('i-select', Select);
Vue.component('i-option', Option);
Vue.component('i-table', Table);
Vue.component('i-spin', Spin);
Vue.component('i-page', Page);
Vue.component('i-dropdown', Dropdown);
Vue.component('i-dropdown-menu', DropdownMenu);
Vue.component('i-dropdown-item', DropdownItem);
Vue.component('i-tag', Tag);
Vue.component('i-divider', Divider);
Vue.component('i-row', Row);
Vue.component('i-col', Col);
Vue.component('i-button', Button);
Vue.component('i-alert', Alert);
Vue.component('i-badge', Badge);
Vue.component('i-radio', Radio);
Vue.component('i-radio-group', RadioGroup);
Vue.component('i-dialog', Modal);
Vue.component('i-list', List);
Vue.component('i-list-item', List.Item);
Vue.component('i-progress', Progress);
Vue.component('i-timeline', Timeline);
Vue.component('i-timeline-item', TimelineItem);

Vue.prototype.$Message = Message;
Vue.prototype.$Modal = Modal;
